import React, { useEffect, useRef, useState } from "react";
import { Card, Typography, Input, Button, Space } from "antd";
import { If } from "react-condition";
import { EditFilled, EditOutlined } from "@ant-design/icons";
import { set } from "lodash";

const { Title, Text } = Typography;

const OtpVerification = ({
  type,
  handleVerify,
  alert,
  reSendOtp,
  emailOrPhone,
  setIsOtpSent,
  setAlert
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputs = useRef([]);

  const [timer, setTimer] = useState(60);

  useEffect(() => {
    if (timer === 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pasteData = e.clipboardData.getData("text").trim();

    if (!/^\d{6}$/.test(pasteData)) return;

    const newOtp = pasteData.split("");
    setOtp(newOtp);

    inputs.current[5]?.focus();
  };

  const handleResend = async (e) => {
    await reSendOtp(e);
    setOtp(["", "", "", "", "", ""]);
    setTimer(60);
  };

  return (
    <div
      style={{
        maxWidth: 420,
        width: "100%",
        background: "#ffffff",
        textAlign: "center",
      }}
    >
      <h2 style={{ fontWeight: 600, marginBottom: 10 }}>Verify OTP</h2>

      <p style={{ color: "#6b7280", marginBottom: 15 }}>
        Enter the 6-digit OTP sent to <br></br>{" "}
        <b
          onClick={() => {
            setIsOtpSent(false);
            setOtp(["", "", "", "", "", ""]);
            setTimer(60);
            setAlert("");
          }}
          className="flex justify-center items-center gap-[5px] cursor-pointer"
        >
          {emailOrPhone} <EditFilled />
        </b>
      </p>

      <If test={alert !== ""}>
        <div className="alert alert-danger">{alert}</div>
      </If>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 30,
        }}
      >
        {otp.map((digit, index) => (
          <Input
            type="tel"
            key={index}
            value={digit}
            maxLength={1}
            style={{
              width: 50,
              height: 50,
              textAlign: "center",
              fontSize: 20,
              borderRadius: 10,
              border: "1px solid #e5e7eb",
            }}
            ref={(el) => (inputs.current[index] = el)}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={index === 0 ? handlePaste : undefined}
          />
        ))}
      </div>

      <Button
        block
        disabled={otp.join("").length !== 6}
        onClick={() => handleVerify(otp.join(""))}
        style={{
          height: 48,
          borderRadius: 10,
          fontWeight: 500,
          fontSize: 16,
          background:
            "linear-gradient(41deg, rgb(241,120,35) 0%, rgb(248,166,27) 100%)",
          border: "none",
        }}
        type="primary"
      >
        Verify OTP
      </Button>

      {/* Resend Section */}
      <div style={{ marginTop: 20 }}>
        {timer > 0 ? (
          <span style={{ color: "#9ca3af" }}>Resend OTP in {timer}s</span>
        ) : (
          <Button
            type="link"
            onClick={handleResend}
            style={{ padding: 0, fontWeight: 500 }}
          >
            Resend OTP
          </Button>
        )}
      </div>
    </div>
  );
};

export default OtpVerification;
